import React from 'react';
import { _Switch } from "./styles";
export function Switch(props) {
  return /*#__PURE__*/React.createElement(_Switch, props);
}